import type { FC } from 'react';

interface IH2Props {
  children: string;
}

const H3: FC<IH2Props> = ({ children }) => {
  return (
    <h3 className="font-semibold text-[24px] leading-[32px]">{children}</h3>
  );
};

export default H3;
